/* ── Spring Revolution Wishlist ── */
(function () {
  var KEY = 'sr_wishlist';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function save(list) { localStorage.setItem(KEY, JSON.stringify(list)); }

  function isIn(id) {
    return load().some(function (p) { return String(p.id) === String(id); });
  }

  function toggle(product) {
    var list = load();
    var idx = list.findIndex(function (p) { return String(p.id) === String(product.id); });
    if (idx === -1) { list.push(product); } else { list.splice(idx, 1); }
    save(list);
    updateAllButtons();
    updateCount();
  }

  function updateCount() {
    var n = load().length;
    document.querySelectorAll('.sr-wl-count').forEach(function (el) {
      el.textContent = n;
      el.style.cssText = n > 0
        ? 'display:flex!important;align-items:center;justify-content:center;'
        : 'display:none!important;';
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('.sr-wl-btn').forEach(function (btn) {
      if (isIn(btn.dataset.productId)) {
        btn.classList.add('sr-wl-active');
      } else {
        btn.classList.remove('sr-wl-active');
      }
    });
  }

  function initButtons() {
    document.querySelectorAll('.sr-wl-btn').forEach(function (btn) {
      if (btn.dataset.srWlInit) return;
      btn.dataset.srWlInit = '1';
      if (isIn(btn.dataset.productId)) btn.classList.add('sr-wl-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle({
          id:     btn.dataset.productId,
          handle: btn.dataset.productHandle,
          title:  btn.dataset.productTitle,
          image:  btn.dataset.productImage,
          price:  btn.dataset.productPrice,
          url:    btn.dataset.productUrl
        });
      });
    });
  }

  function removeItem(id) {
    var list = load().filter(function (p) { return String(p.id) !== String(id); });
    save(list);
    updateAllButtons();
    updateCount();
    renderPage();
  }

  function clearAll() {
    save([]);
    updateAllButtons();
    updateCount();
    renderPage();
  }

  var BAG_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var ATC_LABEL = 'Aggiungi al carrello';

  function addToCart(handle, btn) {
    btn.disabled = true;
    btn.innerHTML = BAG_ICON + '<span>...</span>';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        });
      })
      .then(function () {
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><polyline points="20 6 9 17 4 12"/></svg><span>Aggiunto!</span>';
        btn.classList.add('sr-wl-atc-success');
        if (typeof window.refreshCartDrawer === 'function') {
          window.refreshCartDrawer();
        }
        setTimeout(function () {
          btn.innerHTML = BAG_ICON + '<span>' + ATC_LABEL + '</span>';
          btn.classList.remove('sr-wl-atc-success');
          btn.disabled = false;
        }, 2200);
      })
      .catch(function () {
        btn.innerHTML = BAG_ICON + '<span>' + ATC_LABEL + '</span>';
        btn.disabled = false;
      });
  }

  function renderPage() {
    var wrap = document.getElementById('sr-wl-root');
    if (!wrap) return;
    var list = load();
    if (list.length === 0) {
      wrap.innerHTML =
        '<div class="sr-wl-empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/></svg>' +
        '<p>Non hai ancora aggiunto prodotti ai preferiti.</p>' +
        '<a href="/pages/tutti-i-prodotti" class="sr-wl-empty-btn">Scopri i prodotti</a>' +
        '</div>';
      return;
    }

    var header =
      '<div class="sr-wl-page-header">' +
        '<span class="sr-wl-page-count">' + list.length + ' ' + (list.length === 1 ? 'prodotto' : 'prodotti') + '</span>' +
        '<button class="sr-wl-clear-btn" id="sr-wl-clear">Svuota lista</button>' +
      '</div>';

    var grid = '<div class="sr-wl-grid">';
    list.forEach(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '';
      grid +=
        '<div class="sr-wl-card">' +
          '<div class="sr-wl-card-img">' +
            '<a href="' + p.url + '">' + img + '</a>' +
            '<button class="sr-wl-remove-btn" data-id="' + p.id + '" aria-label="Rimuovi dai preferiti">' +
              '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="sr-wl-card-info">' +
            '<a href="' + p.url + '" class="sr-wl-card-title">' + p.title + '</a>' +
            '<div class="sr-wl-card-price">' + p.price + '</div>' +
            '<button class="sr-wl-card-btn" data-handle="' + p.handle + '">' + BAG_ICON + '<span>' + ATC_LABEL + '</span></button>' +
          '</div>' +
        '</div>';
    });
    grid += '</div>';

    wrap.innerHTML = header + grid;

    document.getElementById('sr-wl-clear').addEventListener('click', function () {
      if (confirm('Rimuovere tutti i prodotti dalla lista preferiti?')) clearAll();
    });
    wrap.querySelectorAll('.sr-wl-remove-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { removeItem(btn.dataset.id); });
    });
    wrap.querySelectorAll('.sr-wl-card-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn.dataset.handle, btn); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateCount();
    renderPage();
  });
})();
